export type AppRole = "solo" | "agency_admin" | "realtor" | "brokerage_parent" | "brokerage_sub"

export function getDashboardRouteForRole(role?: string | null): "/admin" | "/subaccount" {
  return role === "brokerage_sub" ? "/subaccount" : "/admin"
}

type PostAuthRouteUserLike = {
  role?: string | null
  onboardingComplete?: boolean | null
  profileSlug?: string | null
}

export function getPostAuthRoute(user?: PostAuthRouteUserLike | null): "/onboarding" | "/admin" | "/subaccount" {
  if (user?.onboardingComplete === false) {
    return "/onboarding"
  }
  return getDashboardRouteForRole(user?.role)
}
